import styles from './index.module.less';
import Link from 'next/link';
import TopHero from './cpns/TopHero';
import Summary from './cpns/Summary';
import Compare from './cpns/Compare';
import Price from './cpns/Price';
import Why from './cpns/Why';
import Advantage from './cpns/Advantage';
import FAQDataOut from './cpns/FAQDataOut';

const BottomFolder = dynamic(() => import('./cpns/BottomFolder'), {
  ssr: true,
});
import dynamic from 'next/dynamic';
const TwoBlogSec = dynamic(() => import('@/components/Common/TwoBlogSec'), {
  ssr: true,
});
const CustomersTalkUsContent = dynamic(() => import('@/components/Common/CustomersTalkUsContent'), {
  ssr: true,
});

import { useUserProvider } from '@/context/UserProvider';
import { useRouter } from 'next/router';

const Index = ({ data }: { data: any }) => {
  const { isLogin, onOpenLoginModal } = useUserProvider();
  const router = useRouter();
  const handleConfirm = () => {
    if (!isLogin) {
      onOpenLoginModal(true);
    } else {
      router.push('/dashboard');
    }
  };
  return (
    <div className={styles.container}>
      <ul className={styles.crumbs}>
        <li>
          <Link href="/">Home</Link>
        </li>
        <li>{'>'}</li>
        <li>
          <Link href="/alternatives">{data.contentInfo.alternativeBasic.title}</Link>
        </li>
      </ul>
      <TopHero hero={data.contentInfo.hero} confirm={handleConfirm} />
      <Summary
        compareSummary={data.contentInfo['compare-summary']}
        alternativeBasic={data.contentInfo.alternativeBasic}
        websiteBasic={data.contentInfo.websiteBasic}
      />
      <Compare
        alternativeBasic={data.contentInfo.alternativeBasic}
        websiteBasic={data.contentInfo.websiteBasic}
        compareFeature={data.contentInfo['compare-feature']}
      />
      <Price
        price={data.contentInfo['compare-price']}
        alternativeBasic={data.contentInfo.alternativeBasic}
        websiteBasic={data.contentInfo.websiteBasic}
        confirm={handleConfirm}
      />
      <Why why={data.contentInfo['compare-why']} />
      <Advantage advantage={data.contentInfo['compare-advantage']} />
      <TwoBlogSec
        blogList={data.blogList}
        topBlogList={data.topBlogList}
        blogTitle={data.contentInfo['section-blog'].title}
        topBlogTitle={data.contentInfo['section-top-blog'].title}
      />
      {data.contentInfo['section-testimonial']?.title && (
        <CustomersTalkUsContent content={data.contentInfo['section-testimonial']} />
      )}
      <FAQDataOut content={data.faqList} />
      <BottomFolder cta={data.contentInfo.cta} confirm={handleConfirm} />
      <div className={styles.fix}>
        <div className={styles.btn} onClick={handleConfirm}>
          Switch Now
        </div>
      </div>
    </div>
  );
};

export default Index;
